import { Box, Container, Divider, Paper } from '@mui/material'
import HeaderBlock from './headerBlock'
import SegmentHeader from './segmentHeader'
import FlightSegment from './flightSegment'
// import Layover from './layover'
import FareCards from './fareCards'
import TransparencyWidget from './transparencyWidget'
import ContinueButton from './continueButton'
import PriceSummary from './priceSummary'
import CouponTray from './couponTray'

const ItineraryLoadingShimmer = () => {
    return (
        <Container maxWidth="xl" sx={{ px: 2, minHeight: '100vh' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: 2,
                    alignItems: 'flex-start',
                    mx: 'auto',
                    pb: 6,
                    pt: 2,
                    px: 2
                }}
            >
                {/* Main Content */}
                <Box component="main" sx={{ flex: 1, minWidth: 0, width: '100%' }}>
                    <Paper
                        elevation={0}
                        sx={{
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'borders.default',
                            p: 2,
                            width: '100%'
                        }}
                    >
                        <HeaderBlock />
                        <SegmentHeader />
                        <FlightSegment />
                        <Divider sx={{ mt: 4 }} />
                        {/* <Layover /> */}
                        <FareCards />
                        <TransparencyWidget />
                    </Paper>

                    <ContinueButton />
                </Box>

                {/* Sidebar Shimmer */}
                <Box
                    sx={{
                        width: { xs: '100%', md: '300px' },
                        flexShrink: 0,
                        alignSelf: 'flex-start',
                        position: { md: 'sticky' },
                        top: { md: 16 }
                    }}
                >
                    <PriceSummary />
                    <CouponTray />
                </Box>
            </Box>
        </Container>
    )
}

export default ItineraryLoadingShimmer
